// Amplify settings
import Auth from '@aws-amplify/auth'
import API from '@aws-amplify/api'

// init amplify setting
API.configure({
	endpoints: [
		{
			name: 'PVAPI',
			endpoint: process.env.VUE_APP_PVAPI
		}
	]
})

Auth.configure({
	region: process.env.VUE_APP_region,
	userPoolId: process.env.VUE_APP_userPoolId,
	userPoolWebClientId: process.env.VUE_APP_userPoolWebClientId,
	identityPoolId: process.env.VUE_APP_identityPoolId,
	// OPTIONAL - Configuration for cookie storage
	// Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
})
